import { Video as LucideIcon } from 'lucide-react';
import * as Icons from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  Award: Icons.Award,
  Building: Icons.Building,
  Building2: Icons.Building2,
  Calendar: Icons.Calendar,
  CheckCircle: Icons.CheckCircle,
  Circle: Icons.Circle,
  ClipboardCheck: Icons.ClipboardCheck,
  ClipboardList: Icons.ClipboardList,
  Clock: Icons.Clock,
  Cog: Icons.Cog,
  Columns: Icons.Columns,
  Construction: Icons.Construction,
  Eye: Icons.Eye,
  FileCheck: Icons.FileCheck,
  Globe: Icons.Globe,
  Grid3X3: Icons.Grid3X3,
  HardHat: Icons.HardHat,
  Heart: Icons.Heart,
  Home: Icons.Home,
  Key: Icons.Key,
  Layers: Icons.Layers,
  Leaf: Icons.Leaf,
  Lightbulb: Icons.Lightbulb,
  MapPin: Icons.MapPin,
  MessageSquare: Icons.MessageSquare,
  Package: Icons.Package,
  PenTool: Icons.PenTool,
  RefreshCw: Icons.RefreshCw,
  Route: Icons.Route,
  Search: Icons.Search,
  Shield: Icons.Shield,
  ShieldCheck: Icons.ShieldCheck,
  Star: Icons.Star,
  Target: Icons.Target,
  Tractor: Icons.Tractor,
  Truck: Icons.Truck,
  User: Icons.User,
  Users: Icons.Users,
  Wallet: Icons.Wallet,
  Wrench: Icons.Wrench,
  Zap: Icons.Zap,
};

export function getIcon(name: string): LucideIcon {
  return iconMap[name] || Icons.Circle;
}
